require('./RAServiceInfo.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const RACommissionTag = require('../RACommissionTag/RACommissionTag');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const {
    recordLink,
    PROC_RA_GLOBAL_POSITION_INTERACTION,
} = require('utilities/tagging');

// @constants
const {
    MANAGEMENT_PLAN_URL,
    PROC_RA_HIRE,
    PROC_RA_GLOBAL_POSITION_MORE_INFO,
    PROC_RA_GLOBAL_POSITION_US_MANAGMENT,
    SUITABILITY_TEST_URL,
} = require('../../raConstants/index');

// @assets
const icon1 = require('../../assets/icons/icon1.svg');
const icon2 = require('../../assets/icons/icon2.svg');
const icon3 = require('../../assets/icons/icon3.svg');
const FlagComercial = require('../../assets/icons/FlagComercial-01.svg');

const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

class RAServiceInfo extends React.Component {
    constructor(props) {
        super(props);

        this.handleHireClick = this.handleHireClick.bind(this);
        this.handleInfoLinkClick = this.handleInfoLinkClick.bind(this);
    }

    handleInfoLinkClick() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_MORE_INFO,
        );
    }

    handleHireClick(ev) {
        const hireLink = ev.target.id || ev.target.closest('button').id;
        this.props.validateResidential(hireLink);
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_HIRE,
            PROC_RA_GLOBAL_POSITION_US_MANAGMENT,
        );
    }

    buildHireLinkButton() {
        const { immCheckStatus } = this.props;
        let hireLink = MANAGEMENT_PLAN_URL;
        if (immCheckStatus.get('newRoboCustomer')) {
            hireLink = SUITABILITY_TEST_URL;
        }
        return (
            <OKButton onClick={this.handleHireClick} id={hireLink}>
                <FormattedText value="raServiceInfo-hire" />
            </OKButton>
        );
    }

    buildHireBlockInfo() {
        const serviceInfoMoney = formatText('raCommons-serviceInfoMoney1');

        return (
            <BlockInfo extraClass="ra-service-info__block-info">
                <p className="ra-service-info__paragraph">
                    <FormattedText value="raServiceInfo-serviceInfoProductDescription1" />
                </p>
                <p className="ra-service-info__paragraph">
                    <FormattedText value="raServiceInfo-serviceInfoProductDescription2" />
                </p>
                <p className="ra-service-info__paragraph">
                    <FormattedText value="raServiceInfo-serviceInfoProductDescription3" />
                </p>
                <p className="ra-service-info__paragraph">
                    <FormattedText
                        value="raServiceInfo-serviceInfoProductDescription4"
                        injectedStrings={[serviceInfoMoney]}
                    />
                </p>
                <span>
                    <FormattedText value="raServiceInfo-serviceInfoProductDescription7" />
                </span>
                <ul>
                    <FormattedText value="cc_raCommons-serviceFee" />
                </ul>
                <p className="ra-service-info__paragraph">
                    <FormattedText value="raServiceInfo-serviceInfoProductDescription6" />
                </p>
            </BlockInfo>
        );
    }

    render() {
        const {
            serviceIsDisabled,
            commisionFlag,
            hasRoboHired,
            immVariables,
        } = this.props;
        const hireLinkButton = serviceIsDisabled
            ? null
            : this.buildHireLinkButton();
        let moreInfoLink;
        if (!__CONTACT_CENTER__) {
            const url = immVariables.get('robo_landing');
            moreInfoLink = (
                <OKLink
                    modifier="complementary"
                    to={url}
                    onClick={this.handleInfoLinkClick}
                >
                    <FormattedText value="raServiceInfo-moreInfo" />
                </OKLink>
            );
        }
        const blockProductInfo =
            __CONTACT_CENTER__ && !hasRoboHired && this.buildHireBlockInfo();

        const featuresClassName = classnames('ra-service-info__features', {
            'ra-service-info__features--clear': serviceIsDisabled,
        });
        const footerClassName = classnames('ra-service-info__footer', {
            'ra-service-info__footer--pull-right': serviceIsDisabled,
        });
        let commissionIcon = FlagComercial;
        let thirdIconDescription =
            'raCommissionTag-raCommissionTag_thirdIconDescription';
        if (commisionFlag) {
            commissionIcon = icon3;
            thirdIconDescription = 'raCommissionTag-raCommissionTag_label2';
        }
        const thirdIconClass = classnames('ra-commission-tag', {
            'ra-commission-tag__label': commisionFlag,
        });

        return (
            <div className="ra-service-info">
                <div className="ra-service-info__image" />
                <section className="ra-service-info__content">
                    <header className="ra-service-info__content-title">
                        <FormattedText value="raServiceInfo-title" />
                        <div className="ra-service-info__commission-tag">
                            <RACommissionTag hideMessage={true} />
                        </div>
                    </header>
                    <p className="ra-service-info__content-description">
                        <FormattedText value="raServiceInfo-description" />
                    </p>
                    <div className={featuresClassName}>
                        <div className="ra-service-info__feature">
                            <img
                                className="ra-service-info__empty-icon"
                                src={icon1}
                            />
                            <p className="ra-service-info__feature-description">
                                <FormattedText value="raServiceInfo-firstIconDescription" />
                            </p>
                        </div>
                        <div className="ra-service-info__feature">
                            <img
                                className="ra-service-info__empty-icon"
                                src={icon2}
                            />
                            <p className="ra-service-info__feature-description">
                                <FormattedText value="raServiceInfo-secondIconDescription" />
                            </p>
                        </div>
                        <div className="ra-service-info__feature">
                            <img
                                className="ra-service-info__empty-icon"
                                src={commissionIcon}
                            />
                            <p className="ra-service-info__feature-description ra-service-info__feature-description--last">
                                <FormattedText
                                    className={thirdIconClass}
                                    value={thirdIconDescription}
                                />
                            </p>
                            <FormattedText value="raServiceInfo-thirdIconDescription" />
                        </div>
                    </div>
                    <ContactCenterRender>
                        {blockProductInfo}
                        <div className="ra-service-info__separator" />
                    </ContactCenterRender>
                    <footer className={footerClassName}>
                        {moreInfoLink}
                        {hireLinkButton}
                    </footer>
                </section>
            </div>
        );
    }
}

RAServiceInfo.propTypes = {
    serviceIsDisabled: PropTypes.bool.isRequired,
    validateResidential: PropTypes.func.isRequired,
    commisionFlag: PropTypes.bool,
    hasRoboHired: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
};

module.exports = RAServiceInfo;
